import { api } from "./client";
import { useResource } from "./useResource";

// Batched code review (A9). A review round publishes the caller's draft diff
// comments and records a summary; `pending` is the caller's unsubmitted draft
// count, including drafts left behind on a superseded snapshot.
export type ReviewHistoryEntry = {
  readonly comment_count: number;
  readonly public_id: string;
  readonly round: number;
  readonly submitted_at: string;
  readonly submitted_by_name: string | null;
  readonly summary: string;
};

export type UseTaskReviews = {
  readonly history: ReadonlyArray<ReviewHistoryEntry>;
  readonly loading: boolean;
  readonly pending: number;
  readonly refetch: () => void;
};

export const useTaskReviews = (taskId: string | null): UseTaskReviews => {
  const { data, loading, refetch } = useResource<{
    history: ReadonlyArray<ReviewHistoryEntry>;
    pending: number;
  }>(taskId ? `/tasks/${taskId}/reviews` : null);
  return {
    history: data?.history ?? [],
    loading,
    pending: data?.pending ?? 0,
    refetch,
  };
};

export const submitReview = (
  taskId: string,
  input: {
    readonly commentIds?: ReadonlyArray<string>;
    readonly summary?: string;
  },
): Promise<unknown> =>
  api.post(`/tasks/${taskId}/reviews`, {
    comment_ids: input.commentIds,
    summary: input.summary,
  });
